import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const AiSparklesIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    {/* Main large sparkle - outline only */}
    <path d="M12 2L15 10L22 12L15 14L12 22L9 14L2 12L9 10L12 2Z" fill="none" stroke="currentColor" strokeWidth="1.5" />
    {/* Small sparkle in top right */}
    <path d="M19 2L20 4.5L22 5L20 5.5L19 8L18 5.5L16 5L18 4.5L19 2Z" fill="currentColor" />
    {/* Small sparkle in bottom right */}
    <path d="M19 16L20 18.5L22 19L20 19.5L19 22L18 19.5L16 19L18 18.5L19 16Z" fill="currentColor" />
  </SvgIcon>
);

export default AiSparklesIcon; 